import { render, staticRenderFns } from "./NoPictureWithExcerpt.vue?vue&type=template&id=58cf31b0&"
import script from "./NoPictureWithExcerpt.vue?vue&type=script&lang=ts&"
export * from "./NoPictureWithExcerpt.vue?vue&type=script&lang=ts&"
import style0 from "./NoPictureWithExcerpt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports